// CartContext.js
import React, { createContext, useState, useContext } from "react";

// Créer le contexte
const CartContext = createContext();

// Fournisseur de panier
export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const addToCart = (formation) => {
    if (cart.length >= 15) {
      alert("Vous avez atteint la limite de 15 formations dans le panier.");
      return;
    }
    if (!cart.includes(formation)) {
      setCart([...cart, formation]);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } else {
      alert(`${formation} est déjà dans le panier.`);
    }
  };

  const handleRemoveFromCart = (formation) => {
    setCart(cart.filter((item) => item !== formation));
  };

  return (
    <CartContext.Provider
      value={{ cart, addToCart, handleRemoveFromCart, showAlert }}
    >
      {children}
    </CartContext.Provider>
  );
}

// Custom hook pour utiliser le contexte
export function useCart() {
  return useContext(CartContext);
}
